import React from 'react';
import './Support.css';

function Support() {
  return (
    <div className="support-page">
      <div className="container">
        <div className="content">
          <h1 className="page-title">技术支持</h1>
          
          <section className="section">
            <h2>欢迎使用 数学可视化引擎</h2>
            <p>
              MathScope 是一款专业的数学计算应用，致力于为用户提供便捷、准确的数学计算体验。
            </p>
          </section>

          <section className="section">
            <h2>常见问题</h2>
            
            <div className="faq-item">
              <h3>如何开始使用？</h3>
              <p>下载并安装应用后，您可以立即开始使用各项数学计算功能。应用界面简洁直观，无需复杂设置。</p>
            </div>

            <div className="faq-item">
              <h3>支持哪些计算功能？</h3>
              <p>数学可视化引擎 支持基础四则运算、科学计算、方程求解等多种数学计算功能。</p>
            </div>

            <div className="faq-item">
              <h3>如何保存计算历史？</h3>
              <p>应用会自动保存您的计算历史记录，您可以随时查看和重用之前的计算结果。</p>
            </div>
          </section>

          <section className="section">
            <h2>联系我们</h2>
            <p>
              如果您在使用过程中遇到任何问题，或有任何建议和反馈，欢迎通过以下方式联系我们：
            </p>
            <div className="contact-info">
              <p><strong>邮箱：</strong> wsmslgh@gmail.com</p>
              <p><strong>反馈：</strong> 您也可以在 App Store 中给我们留下评价和建议</p>
            </div>
          </section>

          <section className="section">
            <h2>系统要求</h2>
            <ul className="requirements-list">
              <li>iOS 15.0 或更高版本</li>
              <li>iPhone</li>
            </ul>
          </section>

          <section className="section">
            <h2>版本更新</h2>
            <p>
              我们会持续优化应用性能，修复已知问题，并添加新功能。请保持应用更新至最新版本以获得最佳体验。
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}

export default Support;
